var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.937,
    height: 46.624,
    viewBox: "0 0 60.937 46.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}.b{fill:none;stroke:#162d43;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-359.5 -1119.405)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.471,0A21.534,21.534,0,0,0,0,21.471V42.942H21.471V21.471H7.157A14.265,14.265,0,0,1,21.471,7.157ZM57.257,0A21.534,21.534,0,0,0,35.785,21.471V42.942H57.257V21.471H42.942A14.265,14.265,0,0,1,57.257,7.157Z",
    transform: "translate(363.181 1123.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.471,0A21.534,21.534,0,0,0,0,21.471V42.942H21.471V21.471H7.157A14.265,14.265,0,0,1,21.471,7.157ZM57.257,0A21.534,21.534,0,0,0,35.785,21.471V42.942H57.257V21.471H42.942A14.265,14.265,0,0,1,57.257,7.157Z",
    transform: "translate(360 1119.905)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQts);
export default __webpack_public_path__ + "static/media/qts.cf27d6bb8acef8c7c08da1329f93b23f.svg";
export { ForwardRef as ReactComponent };